var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1252 1282.8",
    style: {
      enableBackground: "new 0 0 1252 1282.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#221F1F;stroke:#FFFFFF;}\n\t.st2{fill:#FEFEFE;}\n\t.st3{fill:#BEBEBE;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -6,
    className: "st1",
    width: 1252,
    height: 1288.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "HISTORY"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "888.8,402.6 374.9,402.6 493.8,518.7 769.6,518.7 769.6,830.4 668.9,934.3 1106.8,934.3  1106.7,934.1 888.8,836.7 888.8,114.5 888.8,114.5 670.9,24.1 670.7,24.1 769.6,126.9 769.6,321.8 769.9,321.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "156.5,934.3 594.4,934.3 594.3,934.2 374.9,836.7 374.9,402.6 374.9,402.6 374.9,402.6 374.9,114.5  158,24.1 157.7,24.1 257.9,127.2 257.9,830.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "374.9,836.7 594.3,934.2 493.7,830.4 493.7,518.7 493.7,518.7 493.8,518.7 374.9,402.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "888.8,114.5 888.8,836.7 1106.7,934.1 1005.4,830.4 1005.4,127.2 1105.6,24.1 670.9,24.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "374.9,402.6 374.9,402.6 888.8,402.6 769.9,321.8 769.6,321.8 493.8,321.8 493.7,321.8 493.7,126.9  592.7,24.1 158,24.1 374.9,114.5 374.9,402.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.4,1069h54v67.3h53.5V1069h54v177.2h-54v-70.6h-53.5v70.6h-54L47.4,1069L47.4,1069z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M245.9,1069h54v177.2h-54V1069z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M448.1,1118.1c-10.6-11.2-23-15.6-39.6-15.6c-13.5,0-22.7,4.4-22.7,12.7c0,28.6,103.9,3.2,103.9,75.4 c0,29.3-25,59.1-80.4,59.1c-33.8,0-63.5-7.5-83.6-34.5l32.5-23.7c11.8,13.6,28.2,21.5,47.6,21.5c21.3,0,29.8-7.8,29.8-15.5 c0-27-102.3-6.3-102.3-73.4c0-34.6,30.8-58.3,76.1-58.3c26.5,0,53.5,7.5,70.4,28L448.1,1118.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M548.4,1107h-52v-38h158.2v38h-52v139.2h-54V1107H548.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M751.2,1249.6c-56.3,0-90.4-35.4-90.4-91.9c0-56.6,34-91.9,90.4-91.9c56.3,0,90.3,35.4,90.3,91.9 S807.5,1249.6,751.2,1249.6z M717.9,1157.7c0,47.6,14.7,56.7,33.3,56.7c18.3,0,33.3-9.1,33.3-56.7c0-45.1-12.3-56.7-33.3-56.7 C729.4,1101,717.9,1114.8,717.9,1157.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M863.8,1069h90.5c63.1,0,75.3,28.1,75.3,51.1c0,22.1-14.7,36.8-35.7,44.5l35.3,81.6h-60.1l-26.7-72.6H918 v72.6h-54V1069H863.8z M917.8,1139.9h28.1c15.5,0,26.7-6.3,26.7-17.8c0-11.2-7.8-19.3-24.5-19.3H918v37H917.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1096.5,1171.1L1028,1069h61.3l39.6,60.3l37.9-60.3h49.1l-65.1,97.8v79.4h-54v-75.2H1096.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1183.6,1246.4h-2.5v-17.8h-5.6v-2.1h13.8v2.1h-5.6L1183.6,1246.4L1183.6,1246.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1211.1,1246.4h-2.5V1229h-0.1l-6.3,17.4h-1.7l-6.4-17.4h-0.1v17.4h-2.1v-19.9h3.7l6,15.9l5.9-15.9h3.6v19.9 H1211.1z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "1194,1025.8 1146.5,977 116.7,977 68.9,1025.8  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryca);
export default __webpack_public_path__ + "static/media/historyca.9020fae32f7c86702565d003e333cebc.svg";
export { ForwardRef as ReactComponent };